import { Component, inject, OnInit } from '@angular/core';
import { PrimeNG } from 'primeng/config'
import { ThemeService } from '@core/themes/theme.service';
import { RefreshSchedulerService } from '@core/services/refresh-scheduler.service';
import { TranslateService } from '@ngx-translate/core';
import { LoggerService } from '@core/services/logger.service';

@Component({
  selector: 'app-root',
  template: `<router-outlet></router-outlet>`,
})
export class AppComponent implements OnInit {
  private readonly themeService = inject(ThemeService);
  private readonly refreshScheduler = inject(RefreshSchedulerService);
  private readonly config = inject(PrimeNG)
  private readonly translateService = inject(TranslateService);
  private readonly loggerService = inject(LoggerService);

  ngOnInit(): void {
    // Initialize theme based on hostname
    this.themeService.loadTheme();
    // Schedule daily refresh (to prevent bugs related to ticket reservations for past events/dates)
    this.refreshScheduler.scheduleDailyRefresh();
    // Register Android debug logger
    this.registerAndroidDebugLogger();
  }

  translate(lang: string) {
    this.translateService.use(lang);
    this.translateService.get('primeng').subscribe(res => {
      this.config.setTranslation(res);
    })
  }

  private registerAndroidDebugLogger(): void {
    window.__androidDebugLog = (context: string, data: unknown) => {
      if(typeof context !== 'string') return;
      const parsedData = typeof data === 'string' ? JSON.parse(data) : data;
      this.loggerService.logAndroidDebug(context, parsedData);
    };
  }
}

declare global {
  interface Window {
    __androidDebugLog: (context: string, data: unknown) => void;
  }
}